import {all} from "redux-saga/effects";
import authSagas from "./Auth";
import userSagas from "./User"
import productsSagas from './Products';
import ordersSagas from './Orders';
import invoicesSagas from './Invoices';
import affiliationRequestsSagas from './AffilationRequests';
import affiliatesSagas from './Affiliates';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    userSagas(),
    productsSagas(),
    ordersSagas(),
    invoicesSagas(),
    affiliationRequestsSagas(),
    affiliatesSagas(),
  ]);
}
